
import { callModals } from '../../models/model';
import { Types } from '../action/action';

const initialState = {
  logs: [],
  isLogLoading: false,
  logsInput: {
    // limit: 10,
    offset: 0,
    filter: 'All',
    search: ''
  },
  particularLog: {},
  isParticularLoading: true,
  callHistory: [],
  favLogs: [],
  totalVoicemails: 0,
  totalRecordings: 0,
  isHistoryLoading:true,
  undoStep:0,
  activeLogs:[],
  filpcallConnected:{},
  isCallTimer:false


};

export const callReducer = (state: callModals = initialState, action: any) => {
  let {
    type,
    payloads
  } = action;
  switch (type) {

    case Types.CALL_LOGS_BAR:
      return {
        ...state, logs: payloads.logs, isLogLoading: false
      };
    case Types.MODIFY_CALL_LOGS:
      return {
        ...state, logsInput: payloads.logsInput, isLogLoading: true
      };
    case Types.CALL_DETAIL_PAGE:
      return {
        ...state, particularLog: payloads.particularLog, isParticularLoading: payloads.isParticularLoading
      };
    case Types.CLEAR_CALL_PAGE:
      return {
        ...state, logs: [], particularLog: {}, isParticularLoading: true, callHistory: []
      };

    case Types.CALL_HISTORY_LOADING:
      return {
        ...state, isHistoryLoading: payloads.isHistoryLoading
      };
    case Types.CALL_HISTORY:
      return {
        ...state, callHistory: payloads.callHistory
      };

    case Types.TOTAL_COUNTS:
      return {
        ...state, totalRecordings: payloads.totalRecordings, totalVoicemails: payloads.totalVoicemails
      };

    case Types.UNDO_STEP:
      return {
        ...state, undoStep: payloads.undoStep
      };
    case Types.SET_ACTIVE_LOGS:
      return {
        ...state, activeLogs: payloads.activeLogs
      };
      case Types.FLIP_CALL_CONNECTED:
        return {
          ...state, filpcallConnected: payloads.filpcallConnected
        };    
      
    case Types.CONNECTED_CALL_INFO:
      return {
        ...state, connectedCallInfo: payloads.connectedCallInfo
      };

    case Types.TIMER_STARTED:
      return {
        ...state,isCallTimer:payloads.isCallTimer
      }

    default:
      return state;
  }
};